import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const Root = styled.div`
  display: flex;
  gap: 16px;
  padding: 0 16px;
  border-top: 1px solid ${colors.lightGray21};

  font-family: Roboto;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
`;

export const Label = styled.label`
  all: unset;
  display: flex;
  align-items: center;
  color: ${colors.darkGray1};
  background: none;
  border: none;
  height: 32px;
  padding: 0;
  cursor: pointer;

  &:has(:checked) {
    color: ${colors.blue1};
  }
`;

export const Radio = styled.input`
  all: unset;
`;
